(function () {
  function getEls() {
    // There may be multiple open buttons / overlays after filters.
    // Always work with the *last* ones (most recently rendered).
    var openBtns = Array.prototype.slice.call(
      document.querySelectorAll("#gush-guide-open")
    );
    var overlays = Array.prototype.slice.call(
      document.querySelectorAll("#gush-guide-overlay")
    );

    var openBtn = openBtns.length ? openBtns[openBtns.length - 1] : null;
    var overlay = overlays.length ? overlays[overlays.length - 1] : null;

    // Remove older duplicate overlays (keep only the last one)
    if (overlays.length > 1) {
      overlays.slice(0, -1).forEach(function (ov) {
        if (ov && ov.parentNode) {
          ov.parentNode.removeChild(ov);
        }
      });
    }

    var closeBtn = overlay
      ? overlay.querySelector("#gush-guide-close") ||
        overlay.querySelector("[data-gush-guide-close]")
      : null;

    var banner = document.querySelector(".gush-guide-banner");

    return { openBtn: openBtn, overlay: overlay, closeBtn: closeBtn, banner: banner };
  }

  function ensureOverlayOnBody(overlay) {
    if (overlay && overlay.parentNode !== document.body) {
      document.body.appendChild(overlay);
    }
  }

  function lockScroll(lock) {
    var root = document.documentElement;
    var body = document.body;
    if (lock) {
      root.style.overflow = "hidden";
      body.style.overflow = "hidden";
    } else {
      root.style.overflow = "";
      body.style.overflow = "";
    }
  }

  function openOverlay(openBtn, overlay, closeBtn) {
    if (!overlay) return;
    ensureOverlayOnBody(overlay);
    overlay.style.display = "block";
    overlay.setAttribute("data-gush-open", "true");
    lockScroll(true);
    try {
      closeBtn && closeBtn.focus();
    } catch (e) {}
  }

  function closeOverlay(openBtn, overlay) {
    if (!overlay) return;
    ensureOverlayOnBody(overlay);
    overlay.style.display = "none";
    overlay.removeAttribute("data-gush-open");
    lockScroll(false);
    try {
      openBtn && openBtn.focus();
    } catch (e) {}
  }

  // CLICK HANDLING VIA EVENT DELEGATION
  document.addEventListener("click", function (e) {
    var els = getEls();
    if (!els.openBtn || !els.overlay) return;

    var openClick =
      e.target === els.openBtn || els.openBtn.contains(e.target);
    var closeClick =
      els.closeBtn &&
      (e.target === els.closeBtn || els.closeBtn.contains(e.target));
    var overlayBgClick = e.target === els.overlay;

    if (openClick) {
      openOverlay(els.openBtn, els.overlay, els.closeBtn);
      return;
    }

    if (closeClick || overlayBgClick) {
      closeOverlay(els.openBtn, els.overlay);
      return;
    }
  });

  // ESC TO CLOSE (works with the latest overlay)
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var els = getEls();
    if (!els.overlay || els.overlay.style.display !== "block") return;
    closeOverlay(els.openBtn, els.overlay);
  });

  // ONE-TIME CTA PULSE (initial page load only)
  document.addEventListener("DOMContentLoaded", function () {
    try {
      var els = getEls();
      if (!els.openBtn || !els.banner) return;

      var key = "gushGuidePulseSeen";
      if (sessionStorage.getItem(key) === "1") return;

      function pulse() {
        els.openBtn.classList.add("is-pulsing");
        sessionStorage.setItem(key, "1");
        els.openBtn.addEventListener(
          "animationend",
          function () {
            els.openBtn.classList.remove("is-pulsing");
          },
          { once: true }
        );
      }

      if ("IntersectionObserver" in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                pulse();
                io.disconnect();
              }
            });
          },
          { threshold: 0.5 }
        );
        io.observe(els.banner);
      } else {
        setTimeout(pulse, 800);
      }
    } catch (e) {}
  });
})();
